import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

export const useEnableProductDetailsDrawerV3 = () => useFeatureFlag(FeatureFlagDeclarations.enableProductDetailsDrawerV3);
